import React from "react";
import { connect } from "react-redux";
import { Alert } from "reactstrap";
import { SUBMIT_SUGGESTION_SUCCEEDED } from "./SuggestionsContainer.js";
import { BAD_COMMENT_SUBMITTED } from "./profecomments/NewCommentContainer";

// ===== ACTIONS
const HIDE_TOASTS = "HIDE_TOASTS";

// ===== REDUCER
const initialState = {
	success: "",
	show: false
};
export const ToastsReducer = function(state = initialState, action) {
	switch (action.type) {
		case HIDE_TOASTS:
			return {
				...state,
				show: false
			};
		case SUBMIT_SUGGESTION_SUCCEEDED:
			return {
				...state,
				color: "success",
				message: "Su sugerencia fue sometida.",
				show: true
			};
		case BAD_COMMENT_SUBMITTED:
			return {
				...state,
				color: "danger",
				message: "Por favor considera tu lenguaje.",
				show: true
			};
		default:
			return state;
	}
};

class Toasts extends React.PureComponent {
	componentDidUpdate() {
		if (this.props.show) {
			setTimeout(() => {
				this.props.onTimeoutReached();
			}, 3000);
		}
	}
	render() {
		return (
			<div className="toast-container">
				<Alert
					color={this.props.color}
					className="toast text-center"
					isOpen={this.props.show}
				>
					{this.props.message}
				</Alert>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		...state.toasts
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onTimeoutReached: () => {
			dispatch({ type: HIDE_TOASTS });
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Toasts);



// WEBPACK FOOTER //
// ./src/containers/ToastsContainer.js